import { type ComponentProps } from 'react'
import { Menu as TamaguiMenu, type MenuProps } from 'tamagui'

// Custom Menu component with default props
export function Menu(props: MenuProps) {
    return (
        <TamaguiMenu
            allowFlip={true}
            offset={8}
            {...props}
        />
    )
}

// Styled Content with default styling
const MenuContent = ({ children, ...props }: ComponentProps<typeof TamaguiMenu.Content>) => (
    <TamaguiMenu.Content
        padding="$1.5"
        borderRadius="$4"
        backgroundColor="$background"
        borderWidth={1}
        borderColor="$borderColor"
        elevate
        minWidth={200}
        {...props}
    >
        {children}
    </TamaguiMenu.Content>
)

// Styled Item with default styling
const MenuItem = ({ children, ...props }: ComponentProps<typeof TamaguiMenu.Item>) => (
    <TamaguiMenu.Item
        gap="$2.5"
        paddingVertical="$2.5"
        paddingHorizontal="$3"
        borderRadius="$3"
        {...props}
    >
        {children}
    </TamaguiMenu.Item>
)

// Re-export all Menu subcomponents
export const MenuTrigger = TamaguiMenu.Trigger
export const MenuPortal = TamaguiMenu.Portal
export { MenuContent, MenuItem }
export const MenuItemTitle = TamaguiMenu.ItemTitle
export const MenuItemIcon = TamaguiMenu.ItemIcon
export const MenuSeparator = TamaguiMenu.Separator
export const MenuCheckboxItem = TamaguiMenu.CheckboxItem
export const MenuItemIndicator = TamaguiMenu.ItemIndicator

// Default export with namespace
const MenuNamespace = Object.assign(Menu, {
    Trigger: MenuTrigger,
    Portal: MenuPortal,
    Content: MenuContent,
    Item: MenuItem,
    ItemTitle: MenuItemTitle,
    ItemIcon: MenuItemIcon,
    Separator: MenuSeparator,
    CheckboxItem: MenuCheckboxItem,
    ItemIndicator: MenuItemIndicator,
})

export default MenuNamespace
